import {SDrawerOrModal, SGeneralForms} from "shj-components";
import {useEffect, useState} from "react";
import {Form, message} from "antd";
import dayjs from "dayjs";
import {isEmpty} from "lodash-es";
import {modifyAppointmentTime} from "@/services/crmTool.ts";

export const EditReservationTimeModal = (props) => {
  const {open, onClose, record = {}, reload} = props
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (open) {
      console.log(record)
      form.setFieldsValue({
        id: record.id,
        appointmentTime: dayjs(record.appointmentTime),
        remark: record.remark
      })
    }
  }, [open]);

  const onSubmit = () => {
    form.validateFields().then(values => {
      setLoading(true)
      modifyAppointmentTime({...values, appointmentTime: dayjs(values.appointmentTime).format('YYYY-MM-DD HH:mm:ss')}).then(res => {
        message.success(res.message || '操作成功')
        onClose()
        reload()
      }).finally(() => {
        setLoading(false)
      })
    })
  }

  return <SDrawerOrModal
      open={open}
      mode={'modal'}
      title={'修改预约时间'}
      width={500}
      onCancel={onClose}
      onOk={onSubmit}
      loading={loading}
  >
    <SGeneralForms
        formConfig={{form}}
        layout={'vertical'}
        configs={[{
          formItem: [
            {name: 'id', hidden: true},
            {
              spanCol: 24,
              label: '修改量房时间',
              name: 'appointmentTime',
              type: 'dateTime',
              required: true,
              rules: [{required: true, message: '不能为空'}],
              comConfig: {
                disabledDate: (current) => current && current < dayjs().subtract(1, 'day')
              }
            },
            {spanCol: 24, label: '备注', name: 'remark'},
          ]
        }]}/>
  </SDrawerOrModal>

}